import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getExtraShifts } from "store/slice/dealerSlice";
import { Accordion, AccordionSummary, AccordionDetails, Button, Typography, Box, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { answerNotification } from "store/slice/dealerSlice";
import ShiftGenerationTable from "layouts/pages/shiftGeneration/ShiftGenerationTable";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "layouts/pages/shiftGeneration/ConfirmationDialog";
import { dealerChnageShift } from "store/slice/shiftsSlice";
import ChangeShiftModal from "layouts/pages/shiftGeneration/ChnageShiftModal";
import { shiftActions } from "store/slice/shiftsSlice";
import { getCurrentShift } from "store/slice/shiftsSlice";
import { pendingShiftRequestsHistory } from "store/slice/shiftsSlice";
import { getShiftLabel } from "utilities";
import { getPartLabel } from "utilities";
import { getNextShift } from "store/slice/shiftsSlice";
import PendingRequests from "./PendingRequest";
import { getMonthInfo } from "store/slice/dealerSlice";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "common/Cards/StatisticsCards/ComplexStatisticsCard";

const DealerHome = () => {
    const userStore = useSelector((state) => state.user);
    const dealerStore = useSelector((state) => state.dealer);
    const shiftStore = useSelector((state) => state.shift);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [shiftRemove, setShiftRemove] = useState(null);
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

    const closeChangeShiftModal = () => {
        dispatch(shiftActions.reset())
        setIsConfirmationDialogOpen(false)
    }

    const { user } = userStore;
    const { extraShifts, studios, monthInfo } = dealerStore;

    const handleConfirmationDialogConfirm = () => {
        dispatch(dealerChnageShift(shiftRemove))
        setIsConfirmationDialogOpen(false);
    }

    const openAddingModal = (shift, date, id) => {
        if (shift) {
            setIsConfirmationDialogOpen(true)
            setShiftRemove(shift)
        }
    };

    useEffect(() => {
        dispatch(pendingShiftRequestsHistory());
      }, [isConfirmationDialogOpen, shiftStore.shifthChange])

    useEffect(() => {
        dispatch(getExtraShifts(""));
        dispatch(getMonthInfo())
    }, [dispatch]);

    useEffect(() => {
        dispatch(getCurrentShift())
        dispatch(getNextShift())
    }, [dealerStore.extraShiftsUpdted])

    const handleAccept = (shift) => {
        dispatch(answerNotification({
            accept: true,
            ...shift
        }));
    };

    const handleReject = ({id,jobId,shiftType,studioId,date, confId}) => {
        dispatch(answerNotification({
            accept: false,
            id,
            jobId,
            confId,
            shiftType,
            studioId,
            date
        }));
    };

    // Map studios by ID for easier lookup
    const studiosData = studios ? studios.reduce((acc, studio) => {
        acc[studio.id] = studio.name;
        return acc;
    }, {}): [];

    // Group shifts by date
    let shiftsByDate = {};
    
    Object.values(extraShifts).forEach(data => {
    
        const { id, shiftType, studioId, available: date, jobId, confId, job, partTimePart, isFull } = data;

        const shift = {
            id,
            job,
            partTimePart,
            date,
            confId,
            jobId,
            studioId,
            isFull,
            studioName: studiosData[studioId] || "Unknown Studio",
            shiftType: shiftType,
            shiftTypeName: shiftType == 2 ? "Night" : "Morning",
        };
        shiftsByDate[date] = shiftsByDate[date] || [];
        shiftsByDate[date].push(shift);
    });

    const handleRequestTimeOff = () => {
        navigate("/request"); // Change path based on your routing
    };
    const shiftDays = monthInfo.days;
    const shiftPnalties = monthInfo.pnalties;

    return (
        <div>
            
            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={4}>
                <Typography variant="h5">Welcome, {user?.name}</Typography>
                <MDButton variant="contained" color="primary" onClick={handleRequestTimeOff}>
                    Request Time Off
                </MDButton>
            </Box>
            
            <MDBox py={3}>
                <Grid container spacing={3}>
                    <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <MDBox mb={1.5}>
                        <ComplexStatisticsCard
                            color="info"
                            icon="work_history"
                            title="Month Working days"
                            count={`${shiftDays?.total ?? 0}/${shiftDays?.worked ?? 0}`}
                        />
                        </MDBox>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <MDBox mb={1.5}>
                        <ComplexStatisticsCard
                            color="info"
                            icon="gavel"
                            title="Month penalties"
                            count={`${shiftPnalties?.total ?? 0 }/${shiftPnalties?.amount ?? 0}`}
                            link="/mistakesHistory"
                        />
                        </MDBox>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <MDBox mb={1.5}>
                        <ComplexStatisticsCard
                            color="info"
                            icon="attach_money"
                            title="Worked Salary"
                            count={`${monthInfo?.salary}`}
                        />
                        </MDBox>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <MDBox mb={1.5}>
                        <ComplexStatisticsCard
                            color="info"
                            icon="card_giftcard"
                            title="Bonus Months"
                            count={`${monthInfo?.bonusMonths ?? 0}`}
                        />
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>

            <PendingRequests studiosData={studiosData}/>

            <Box mt={2}>
                <Typography variant="h4">Extra Shifts</Typography>
                {Object.keys(shiftsByDate).length > 0 ? (
                    Object.entries(shiftsByDate).map(([date, shifts]) => (
                        <Accordion key={date}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h6">Date: {date} </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {shifts.map((shift, index) => {
                                    const job = shift.job;
                                    return (
                                    <Box key={`${shift.studioId}-${shift.shiftType}-${index}`} p={2} border={1} borderRadius={2} mb={2}>
                                        {job?.type === 'swap' && (
                                        <>
                                            <Typography fontWeight="bold">Type: Shift Change Request</Typography>
                                            
                                            {job?.requestedUser?.name && (
                                            <Typography>
                                                Requested to change with: <strong>{job.requestedUser.name}</strong>
                                            </Typography>
                                            )}

                                            {job?.requestedShift && (<>
                                            <Typography>
                                                <b>Requested shift</b>:{" "}
                                                {new Date(job.requestedShift.day).toLocaleDateString()} — Shift:{" "}
                                                {getShiftLabel(job.requestedShift.shift)} {console.log("shift.isFull ", shift.isFull)}
                                                {shift.isFull  == 2 ? " - 1/2 - "+getPartLabel(shift.shiftType): ""} 
                                            </Typography>
                                            <Typography>
                                                <b>Your shift</b>:{" "}
                                                {new Date(date).toLocaleDateString()} — Shift:{" "}
                                                {getShiftLabel(shift.shiftType)}
                                                {shift.isFull == 2 ? " - 1/2 - "+getPartLabel(shift.partTimePart): ""} 
                                            </Typography>
                                            </>)}
                                        </>
                                        )}

                                        {job.type === "dealer_change" && (<>
                                            <Typography>
                                                <b>Type</b>: Dealer change
                                            </Typography>
                                            <Typography>
                                                <b>Requested shift</b>:{" "}
                                                {new Date(job?.requestedShift?.day).toLocaleDateString()} — Shift:{" "}
                                                {getShiftLabel(job?.requestedShift?.shift)}
                                                {job?.requestedShift?.isFull == 2 ? " - 1/2 - "+getPartLabel(shift.shiftType): ""} 
                                            </Typography>
                                        </>)}

                                        <Typography>Studio: {shift.studioName}</Typography>
                                        <Button onClick={() => handleAccept({...shift, isFull: job?.requestedShift?.isFull})} variant="contained" color="primary" sx={{ mr: 1 }} disabled={dealerStore.pendingRequest}>
                                            Accept
                                        </Button>
                                        <Button onClick={() => handleReject(shift)} variant="contained" color="secondary" disabled={dealerStore.pendingRequest}>
                                            Reject
                                        </Button>
                                    </Box>
                                )
                                })}
                            </AccordionDetails>
                        </Accordion>
                    ))
                ) : (
                    <Typography>No extra shifts available</Typography>
                )}
            </Box>
            <Grid mt={5}>
                <Typography variant="h3">Current Shift</Typography>
                <ShiftGenerationTable 
                    openAddingModal={openAddingModal} 
                    shifts={shiftStore?.shift?.shifts} 
                    creationData={shiftStore?.shift?.creationData} 
                    missingDealers={shiftStore?.shift?.missingDealers} 
                />
            </Grid>
           
            {shiftStore?.nextShift.shifts &&  <Grid mt={5}>
                <Typography variant="h3">Next Shift</Typography>
                <ShiftGenerationTable 
                    openAddingModal={openAddingModal} 
                    shifts={shiftStore?.nextShift?.shifts} 
                    creationData={shiftStore?.nextShift?.creationData} 
                    missingDealers={shiftStore?.nextShift?.missingDealers} 
                />
            </Grid>}
            
            <ChangeShiftModal
                openAddignModal={isConfirmationDialogOpen}
                handleModalClose={closeChangeShiftModal}
                onConfirm={handleConfirmationDialogConfirm}
                requestedShift={shiftRemove}
                title="Remove Your Shift"
                message="Are you sure you want to remove your shift?"
            />
        </div>
    );
};

export default DealerHome;
